<template>
  <Select
    @change="onChange"
    v-model="value"
    multiple
    clearable
    :multiple-limit="10"
    collapse-tags
    filterable
    style="width: 100%"
  >
    <OptionGroup v-for="(g, gi) in groups" :key="gi" :label="g.locTypeName">
      <Option
        v-for="(r, i) in roles.filter(x => x.locTypeId == g.locTypeId)"
        :key="i"
        :label="r.roleName + ' - ' + r.description"
        :value="r.roleName"
      ></Option>
    </OptionGroup>
  </Select>
</template>

<script>
import { Select, OptionGroup, Option } from "element-ui";
import { request } from "@/api/all";
var _ = require("lodash");

export default {
  components: {
    Select,
    OptionGroup,
    Option
  },
  props: {
    selected: {
      type: String,
      default: () => ""
    }
  },
  data() {
    return {
      groups: [],
      roles: [],
      value: null
    };
  },
  mounted() {
    request({
      api: { method: "get", url: "Role/getRoleList" },
      store: this.$store
    }).then(res => {
      if (res != false) {
        this.groups = _.uniqBy(res.data.roles, function(e) {
          return e.locTypeId;
        });
        this.roles = res.data.roles;

        if (this.selected != []) {
          this.value = this.selected.split(",");
        }
      }
    });
  },
  methods: {
    onChange(e) {
      this.$emit("input", e.join(", "));
    }
  }
};
</script>

<style></style>
